import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'urql';
import { AppProvider } from '@components/common/context/app';
import { Alert } from '@components/common/modal/Alert';
import Area from '@components/common/Area';
export default function Hydrate(_ref) {
  var {
    client
  } = _ref;
  return /*#__PURE__*/React.createElement(Provider, {
    value: client
  }, /*#__PURE__*/React.createElement(AppProvider, {
    value: window.eContext
  }, /*#__PURE__*/React.createElement(Alert, null, /*#__PURE__*/React.createElement(Area, {
    id: "body",
    className: "wrapper"
  }))));
}
Hydrate.propTypes = {
  client: PropTypes.shape({
    executeQuery: PropTypes.func.isRequired,
    executeMutation: PropTypes.func.isRequired
  }).isRequired
};